import type { ColumnPaginationItemState } from './columnPagination.types'

export const createInitialColumnPaginationItem = (): ColumnPaginationItemState => ({
  hasMore: false,
  loadingMore: false,
  totalCount: null,
})
